import { lazy } from "react";

export const LandingEighthScreenAsync = lazy(() => import("./LandingEighthScreen"));
